<template>
  <span class="svg-ico-skills-domain-digital-ai">
    <svg :style="`width:${width}px;height:${width}px;fill:none;`" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M11.61844 1.81014C11.90284 1.69285 12.22856 1.71258 12.49929 1.86873L20.52467 6.49959C20.83406 6.67817 21.02456 7.00864 21.02469 7.36581V16.63436C21.0246 16.99157 20.83406 17.32196 20.52467 17.50059L12.49929 22.13143C12.19011 22.3098 11.8095 22.30971 11.50029 22.13143L3.47489 17.50059C3.16546 17.322 2.97496 16.99161 2.97489 16.63436V7.36581L2.98368 7.23399C3.02433 6.92884 3.204 6.65593 3.47489 6.49959L11.50029 1.86873L11.61844 1.81014ZM4.9749 7.94297V16.05621L11.99931 20.10994L19.02467 16.05621V7.94297L11.99931 3.88924L4.9749 7.94297Z" :fill="color"/>
    </svg>
  </span>
</template>

<script>
export default {
  props: {
    width: { type: Number, default: 24 },
    color: { type: String, default () { return this && this.$store.state.color['coolGrey-500'] } },
    color2: { type: String, default () { return this && this.$store.state.color['coolGrey-50'] } },
    isFixedColor: { type: Boolean },
    isTwoTone: { type: Boolean },
    isSolid: { type: Boolean }
  }
}
</script>
